export enum AssociatedDocumentType {
  CONSTRUCTOR_PROFORMA = 'CONSTRUCTOR_PROFORMA',
}
